import React from 'react';

interface SortIconProps{
  className?: string;
}

const SortIcon: React.FC<SortIconProps> = ({
  className
}) => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M7.83781 5.53998L5.04779 2.75L2.25781 5.53998" stroke="#003D6B" strokeLinecap="round" stroke-linejoin="round"/>
    <path d="M5.04785 16.25V2.75" stroke="#003D6B" strokeLinecap="round" stroke-linejoin="round"/>
    <path d="M10.1631 13.46L12.9531 16.2499L15.7431 13.46" stroke="#003D6B" strokeLinecap="round" stroke-linejoin="round"/>
    <path d="M12.9531 2.75V16.25" stroke="#003D6B" strokeLinecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export default SortIcon;




